<template>
  <div class="nui-dropdown-divider"></div>
</template>
